module.exports = {
  Handler:  require('./CanvasHandler'),
  Renderer: require('./CanvasRenderer')
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/render/canvas/index.js
// module id = 1529
// module chunks = 0